import { css } from 'styled-components';
import { responsiveProperty } from 'modules/utils/responsiveProperty';
export function getCellCSS(values) {
    if (!values) {
        return undefined;
    }
    const property = 'gridColumn';
    if (typeof values !== 'number') {
        const modifiedValues = Object.keys(values).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: `span ${values[key]}` })), {});
        const cssObject = responsiveProperty(property, modifiedValues);
        return cssObject;
    }
    return css({ [property]: `span ${values}` });
}
